// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/access_context.proto" (package "base", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.AccountContext
 */
export interface AccountContext {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 2
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.OrganizationContext
 */
export interface OrganizationContext {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated string permissions = 2
     */
    permissions: string[];
}
/**
 * @generated from protobuf message base.AccessContext
 */
export interface AccessContext {
    /**
     * @generated from protobuf field: base.AccountContext accountContext = 1
     */
    accountContext?: AccountContext;
    /**
     * @generated from protobuf field: repeated base.OrganizationContext organizationContexts = 2
     */
    organizationContexts: OrganizationContext[];
}
// @generated message type with reflection information, may provide speed optimized methods
class AccountContext$Type extends MessageType<AccountContext> {
    constructor() {
        super("base.AccountContext", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<AccountContext>): AccountContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<AccountContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountContext): AccountContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 2:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue client = 2; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.AccountContext
 */
export const AccountContext = new AccountContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationContext$Type extends MessageType<OrganizationContext> {
    constructor() {
        super("base.OrganizationContext", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "permissions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrganizationContext>): OrganizationContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.permissions = [];
        if (value !== undefined)
            reflectionMergePartial<OrganizationContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationContext): OrganizationContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated string permissions */ 2:
                    message.permissions.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated string permissions = 2; */
        for (let i = 0; i < message.permissions.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.permissions[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.OrganizationContext
 */
export const OrganizationContext = new OrganizationContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessContext$Type extends MessageType<AccessContext> {
    constructor() {
        super("base.AccessContext", [
            { no: 1, name: "accountContext", kind: "message", T: () => AccountContext },
            { no: 2, name: "organizationContexts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationContext }
        ]);
    }
    create(value?: PartialMessage<AccessContext>): AccessContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationContexts = [];
        if (value !== undefined)
            reflectionMergePartial<AccessContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessContext): AccessContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.AccountContext accountContext */ 1:
                    message.accountContext = AccountContext.internalBinaryRead(reader, reader.uint32(), options, message.accountContext);
                    break;
                case /* repeated base.OrganizationContext organizationContexts */ 2:
                    message.organizationContexts.push(OrganizationContext.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.AccountContext accountContext = 1; */
        if (message.accountContext)
            AccountContext.internalBinaryWrite(message.accountContext, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated base.OrganizationContext organizationContexts = 2; */
        for (let i = 0; i < message.organizationContexts.length; i++)
            OrganizationContext.internalBinaryWrite(message.organizationContexts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.AccessContext
 */
export const AccessContext = new AccessContext$Type();
